module.exports = __webpack_public_path__ + "static/media/Agamemnon.b825386a.jpg";